import { useState, type ReactNode } from 'react'
import { PageTitleSetterContext, PageTitleValueContext } from '@/shared/hooks/usePageTitle'

export function PageTitleProvider({ children }: { children: ReactNode }) {
  const [pageTitle, setPageTitle] = useState<string | null>(null)

  return (
    <PageTitleSetterContext.Provider value={setPageTitle}>
      <PageTitleValueContext.Provider value={pageTitle}>{children}</PageTitleValueContext.Provider>
    </PageTitleSetterContext.Provider>
  )
}
